<template>
  <div class="guide-popup" v-if="isUserGuide">
    <cover v-model="isUserGuide"/>

    <div class="popup-container">
      <div class="showing-tab" :style="currentShowingTabTopStyle">
        <svg-icon :name="`${currentTab.iconName}-active`"></svg-icon>
        <span>{{ currentTab.label }}</span>
      </div>
      <div class="popup-info" :style="currentShowingTabTopStyle">
        <div class="popup-bg">
          <svg-icon :name="currentTab.popupInfo && currentTab.popupInfo.iconName"
          :width="72" :height="72"></svg-icon>
        </div>
        <div class="popup-desc">{{ currentTab.popupInfo && currentTab.popupInfo.description }}</div>
        <maf-button :name="currentTab.popupInfo && currentTab.popupInfo.btnText" :width="80"
          @actionFunc="next()"></maf-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GuidePopup',
  props: {
    tabIndex: {
      type: Number,
      default() {
        return 1;
      }
    }
  },
  computed: {
    ...mapState({
      currentTab: state => state.currentTab
    }),
    isUserGuide: {
      get() {
        return this.$store.state.isUserGuide;
      },
      set(value) {
        this.$store.commit('IS_USER_GUIDE_CHANGED', value);
      }
    },
    currentShowingTabTopStyle() {
      const tabTrueHeight = 60;
      return `top: ${tabTrueHeight * this.tabIndex}px`;
    }
  },
  data() {
    return {};
  },
  methods: {
    next() {
      return this.$emit('next');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/main.scss';

.guide-popup {
  position: absolute;
  top: $header-height+20px;
  left: 0;
  width: 100%;
  height: 100%;

  .popup-container {
    position: absolute;
    left: 0;
    z-index: 999999;

    .showing-tab {
      position: absolute;
      left: 0;
      top: 0;
      margin: 5px 0;
      padding-left: 15px;
      padding-right: 15px;
      height: 50px;
      width: $sidebar-width;
      @include inline-flex-row;
      align-items: center;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      transition: all 200ms linear;
      color: $font-color-white;
      background-color: $tab-active;

      .icon {
        margin-right: 10px;
      }

      span {
        flex: 1;
      }
    }

    .popup-info {
      position: absolute;
      left: $sidebar-width+50px;
      top: 0;
      width: 300px;
      height: 319px;
      @include inline-flex-col;
      justify-content: space-between;
      align-items: center;
      border-radius: 7px;
      background-color: $bg-color-white;
      color: $font-color-tab;
      font-size: $font-size-base;
      line-height: $font-size-large;
      overflow: hidden;

      .popup-bg {
        height: 150px;
        width: inherit;
        background-color: $tab-active;
        @include center-style;
      }

      .popup-desc {
        padding: 0 20px;
        flex: 1;
        width: inherit;
        @include center-style;
        text-align: center;
      }

      .maf-btn {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-layout/GuidePopup.vue